import { Flex } from "@kui-react/flex";
import { Stack } from "@kui-react/stack";
import { ThemeProvider } from '@kui-react/theme';

import { PageHeader } from '../PageHeader';
import { PageFooter } from '../PageFooter';

const PageBody = ({ children }) => {
  return (
    <Flex css={{ flexGrow: '1', padding: '$lg' }} justify="center">{children}</Flex>
  );
};

export const Layout = ({ children, signedInUser = null }) => {
  return (
    <ThemeProvider withReset withCanvas theme='dark'>
      <Stack css={{ height: '100vh', backgroundColor: '#111' }}>
        <PageHeader signedInUser={signedInUser} />
        <PageBody>{children}</PageBody>
        <PageFooter />
      </Stack>
    </ThemeProvider>
  );
};

export default Layout;
